var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var PEPHealthService = /** @class */ (function () {
    function PEPHealthService(client) {
        var _this = this;
        this.client = client;
        // private extractPageNumber = (url: string): number => {
        //   const pageNumberMatch = url.match(/page=([0-9]+)/);
        //   if (!pageNumberMatch) throw createError('Invalid url');
        //   return Number(pageNumberMatch[1]);
        // };
        this.mapAPIOrganisationCreationResult = function (body) {
            return {
                name: body.name,
                language: body.language,
            };
        };
        this.createOrganisation = function (name, language) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.createOrganisation(name, language)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPIOrganisationCreationResult(body)];
                }
            });
        }); };
        this.mapAPICurrentOrganisation = function (body) {
            return {
                slug: body.slug,
                name: body.name,
                canBeParent: body.can_be_parent,
                appToken: body.app_token,
                language: body.language,
                ubiquityAppId: body.ubiquity_app_id,
                ubiquityOrganisationId: body.ubiquity_organisation_id,
                ubiquityOrganisationToken: body.ubiquity_organisation_token,
            };
        };
        this.getCurrentOrganisation = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.getCurrentOrganisation()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPICurrentOrganisation(body)];
                }
            });
        }); };
        this.mapAPIChildOrganisation = function (body) {
            return {
                slug: body.slug,
                name: body.name,
                created: body.created,
                canBeParent: body.can_be_parent,
            };
        };
        this.listChildOrganisations = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.listChildOrganisations()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, body.map(this.mapAPIChildOrganisation)];
                }
            });
        }); };
        this.getChildOrganisation = function (slug) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.getChildOrganisation(slug)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPIChildOrganisation(body)];
                }
            });
        }); };
        this.mapAPIOrganisationUser = function (body) {
            var _a, _b;
            return {
                id: body.id,
                email: body.email,
                firstName: body.first_name,
                lastName: body.last_name,
                role: body.role,
                language: body.language,
                phoneNumber: body.phone_number,
                organisation: body.organisation,
                activated: body.activated,
                invitationIds: body.invitation_ids,
                careTeamMember: body.care_team_member,
                profilePictureImageId: (_a = body.profile_picture_image_id) !== null && _a !== void 0 ? _a : null,
                profilePictureUrl: (_b = body.profile_picture_url) !== null && _b !== void 0 ? _b : null,
            };
        };
        this.listOrganisationUsers = function (organisationSlug) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.listOrganisationUsers(organisationSlug)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, body.map(this.mapAPIOrganisationUser)];
                }
            });
        }); };
        this.listAssignableOrganisationUsers = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.listAssignableOrganisationUsers()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, body.map(this.mapAPIOrganisationUser)];
                }
            });
        }); };
        this.inviteOrganisationUser = function (organisationSlug, invite) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.inviteOrganisationUser(organisationSlug, invite)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPIOrganisationUser(body)];
                }
            });
        }); };
        this.editOrganisationUser = function (organisationSlug, userId, edit) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.editOrganisationUser(organisationSlug, userId, edit)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPIOrganisationUser(body)];
                }
            });
        }); };
        this.mapAPIOrganisationUserInvitation = function (body) {
            return {
                id: body.id,
                status: body.status,
                expires: body.expires,
                sentBy: body.sent_by,
                created: body.created,
            };
        };
        this.listOrganisationUserInvitations = function (organisationSlug, userId) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.listOrganisationUserInvitations(organisationSlug, userId)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, body.map(this.mapAPIOrganisationUserInvitation)];
                }
            });
        }); };
        this.resendOrganisationUserInvitation = function (organisationSlug, userId) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.resendOrganisationUserInvitation(organisationSlug, userId)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPIOrganisationUserInvitation(body)];
                }
            });
        }); };
        this.mapAPICareTeamAssignmentPreviewPatientProfile = function (body) {
            return {
                firstName: body.first_name,
                lastName: body.last_name,
            };
        };
        this.mapAPICareTeamAssignmentPreview = function (body) {
            return {
                careTeamMemberId: body.care_team_member_id,
                roleName: body.role_name,
                roleDescription: body.role_description,
                appUserId: body.app_user_id,
                patientProfile: body.patient_profile == null
                    ? null
                    : _this.mapAPICareTeamAssignmentPreviewPatientProfile(body.patient_profile),
                pathwayId: body.pathway_id,
                pathwayName: body.pathway_name,
            };
        };
        this.getOrganisationUserCareTeamAssignmentPreview = function (organisationSlug, userId) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.getOrganisationUserCareTeamAssignmentPreview(organisationSlug, userId)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, {
                                assignments: body.assignments.map(this.mapAPICareTeamAssignmentPreview),
                            }];
                }
            });
        }); };
        this.mapAPIOrganisationUserActivation = function (body) {
            return {
                id: body.id,
                activated: body.activated,
            };
        };
        this.setOrganisationUserActivation = function (organisationSlug, userId, activated) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.setOrganisationUserActivation(organisationSlug, userId, activated)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPIOrganisationUserActivation(body)];
                }
            });
        }); };
        this.mapAPIOrgConfigToIntegrationOrgConfig = function (body) {
            return {
                organisationId: body.organisation_id,
                isEnabled: body.is_enabled,
                data: body.data,
                created: body.created,
                modified: body.modified
            };
        };
        this.mapAPIAppUserPathwayToIAppUserPathway = function (body) {
            return {
                id: body.id,
                url: body.url,
                originalPathway: body.original_pathway,
                currentStageSlug: body.current_stage_slug,
                disabledRuleIds: body.disabled_rule_ids,
                journeyId: body.journey_id,
                isActive: body.is_active,
                ownerId: body.owner_id,
                externalId: body.external_id
            };
        };
        this.mapAPICareTeamMemberToICareTeamMember = function (body) {
            var _a, _b;
            return {
                id: body.id,
                appUserId: body.app_user_id,
                primaryAppUserId: body.primary_app_user_id,
                staffOrganisationId: body.staff_organisation_id,
                staffUserId: body.staff_user_id,
                name: body.name,
                email: body.email,
                phone: body.phone,
                businessName: body.business_name,
                profilePictureImageId: (_a = body.profile_picture_image_id) !== null && _a !== void 0 ? _a : null,
                profilePictureUrl: (_b = body.profile_picture_url) !== null && _b !== void 0 ? _b : null,
                created: body.created,
                modified: body.modified
            };
        };
        this.mapAPICareTeamRoleToICareTeamRole = function (body) {
            return {
                id: body.id,
                name: body.name,
                description: body.description,
                organisationId: body.organisation_id,
                members: body.members.map(_this.mapAPICareTeamMemberToICareTeamMember),
                createdByType: body.created_by_type,
            };
        };
        this.getIntegrationOrgConfig = function (integrationSlug, organisationId) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.getIntegrationOrgConfig(integrationSlug, organisationId)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPIOrgConfigToIntegrationOrgConfig(body)];
                }
            });
        }); };
        this.createIntegrationOrgConfig = function (integrationSlug, configData, organisationId) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.createIntegrationOrgConfig(integrationSlug, configData, organisationId)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPIOrgConfigToIntegrationOrgConfig(body)];
                }
            });
        }); };
        this.updateIntegrationOrgConfig = function (integrationSlug, isEnabled, configData, organisationId) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.updateIntegrationOrgConfig(integrationSlug, isEnabled, configData, organisationId)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPIOrgConfigToIntegrationOrgConfig(body)];
                }
            });
        }); };
        this.assignPathwayToAppUser = function (appUserId, pathwayId, journeyId, disabledRuleIds, externalId) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.assignPathwayToAppUser(appUserId, pathwayId, journeyId, disabledRuleIds, externalId)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPIAppUserPathwayToIAppUserPathway(body)];
                }
            });
        }); };
        this.getAppUserCareTeam = function (appUserId) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.getAppUserCareTeam(appUserId)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, body.map(this.mapAPICareTeamRoleToICareTeamRole)];
                }
            });
        }); };
        this.getAppUserPathwayCareTeam = function (appUserPathwayId) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.getAppUserPathwayCareTeam(appUserPathwayId)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, body.map(this.mapAPICareTeamRoleToICareTeamRole)];
                }
            });
        }); };
        this.createCareTeamRole = function (appUserId, name, description) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.createCareTeamRole(appUserId, name, description)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPICareTeamRoleToICareTeamRole(body)];
                }
            });
        }); };
        this.createCareTeamMember = function (careTeamRoleId, member) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.createCareTeamMember(careTeamRoleId, member)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPICareTeamMemberToICareTeamMember(body)];
                }
            });
        }); };
        this.editCareTeamMember = function (careTeamMemberId, member) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.editCareTeamMember(careTeamMemberId, member)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPICareTeamMemberToICareTeamMember(body)];
                }
            });
        }); };
        this.deleteCareTeamRole = function (careTeamRoleId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.deleteCareTeamRole(careTeamRoleId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.deleteCareTeamMember = function (careTeamMemberId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.deleteCareTeamMember(careTeamMemberId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.getAppUsersCareTeam = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.getAppUsersCareTeam()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, body.map(this.mapAPICareTeamRoleToICareTeamRole)];
                }
            });
        }); };
        this.deleteAppUsersCareTeamMember = function (careTeamMemberId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.deleteAppUsersCareTeamMember(careTeamMemberId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.createAppUsersCareTeamMember = function (careTeamRoleId, member) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.createAppUsersCareTeamMember(careTeamRoleId, member)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPICareTeamMemberToICareTeamMember(body)];
                }
            });
        }); };
        this.createAppUsersCareTeamRole = function (name, description) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.createAppUsersCareTeamRole(name, description)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPICareTeamRoleToICareTeamRole(body)];
                }
            });
        }); };
        this.mapAPIProfilePicture = function (body) {
            var _a, _b;
            return {
                targetUserId: body.target_user_id,
                profilePictureImageId: (_a = body.profile_picture_image_id) !== null && _a !== void 0 ? _a : null,
                profilePictureUrl: (_b = body.profile_picture_url) !== null && _b !== void 0 ? _b : null,
            };
        };
        this.mapAPIProfilePictureOperation = function (body) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return {
                operationId: body.operation_id,
                action: body.action,
                status: body.status,
                committed: body.committed,
                targetUserId: body.target_user_id,
                expectedProfilePictureImageId: (_a = body.expected_profile_picture_image_id) !== null && _a !== void 0 ? _a : null,
                profilePictureImageId: (_b = body.profile_picture_image_id) !== null && _b !== void 0 ? _b : null,
                profilePictureUrl: (_c = body.profile_picture_url) !== null && _c !== void 0 ? _c : null,
                candidateImageId: (_d = body.candidate_image_id) !== null && _d !== void 0 ? _d : null,
                uploadUrl: (_e = body.upload_url) !== null && _e !== void 0 ? _e : null,
                uploadExpiresAt: (_f = body.upload_expires_at) !== null && _f !== void 0 ? _f : null,
                retryAfterSeconds: (_g = body.retry_after_seconds) !== null && _g !== void 0 ? _g : null,
                errorCode: (_h = body.error_code) !== null && _h !== void 0 ? _h : null,
            };
        };
        this.mapProfilePictureOperationResult = function (response) { return __awaiter(_this, void 0, void 0, function () {
            var body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, response.json()];
                    case 1:
                        body = _a.sent();
                        return [2 /*return*/, {
                                httpStatus: response.status,
                                retryAfterHeader: response.headers.get('Retry-After'),
                                operation: this.mapAPIProfilePictureOperation(body),
                            }];
                }
            });
        }); };
        this.getOwnProfilePicture = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.getOwnProfilePicture()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPIProfilePicture(body)];
                }
            });
        }); };
        this.getOrganisationUserProfilePicture = function (organisationSlug, userId) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.getOrganisationUserProfilePicture(organisationSlug, userId)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPIProfilePicture(body)];
                }
            });
        }); };
        /**
         * Prepare a Profile Picture replacement for the signed-in Organisation User.
         * Pending preparation retries this same POST with the same Idempotency-Key.
         * If the upload URL cannot be retrieved, start a new operation only after the
         * backend terminates the old one and refresh canonical state with a new key.
         */
        this.prepareOwnProfilePicture = function (expectedProfilePictureImageId, idempotencyKey) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.prepareOwnProfilePicture(expectedProfilePictureImageId, idempotencyKey)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.mapProfilePictureOperationResult(response)];
                }
            });
        }); };
        /**
         * Prepare a Profile Picture replacement for a managed Organisation User.
         * Pending preparation retries this same POST with the same Idempotency-Key.
         * If the upload URL cannot be retrieved, start a new operation only after the
         * backend terminates the old one and refresh canonical state with a new key.
         */
        this.prepareOrganisationUserProfilePicture = function (organisationSlug, userId, expectedProfilePictureImageId, idempotencyKey) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.prepareOrganisationUserProfilePicture(organisationSlug, userId, expectedProfilePictureImageId, idempotencyKey)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.mapProfilePictureOperationResult(response)];
                }
            });
        }); };
        /**
         * Clear the signed-in Organisation User's Profile Picture.
         * Pending or uncertain clear retries this same DELETE with the same
         * Idempotency-Key and expected-image body.
         */
        this.clearOwnProfilePicture = function (expectedProfilePictureImageId, idempotencyKey) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.clearOwnProfilePicture(expectedProfilePictureImageId, idempotencyKey)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.mapProfilePictureOperationResult(response)];
                }
            });
        }); };
        /**
         * Clear a managed Organisation User's Profile Picture.
         * Pending or uncertain clear retries this same DELETE with the same
         * Idempotency-Key and expected-image body.
         */
        this.clearOrganisationUserProfilePicture = function (organisationSlug, userId, expectedProfilePictureImageId, idempotencyKey) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.clearOrganisationUserProfilePicture(organisationSlug, userId, expectedProfilePictureImageId, idempotencyKey)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.mapProfilePictureOperationResult(response)];
                }
            });
        }); };
        /**
         * Observe a Profile Picture operation's current state.
         * This is a status read only; it must not initiate or reapply an uncommitted mutation.
         * Pending or uncertain replacement finalisation retries finaliseProfilePictureOperation;
         * pending or uncertain clear retries the original clear DELETE.
         */
        this.getProfilePictureOperation = function (operationId) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.getProfilePictureOperation(operationId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.mapProfilePictureOperationResult(response)];
                }
            });
        }); };
        /**
         * Finalise a prepared Profile Picture replacement.
         * Pending or uncertain replacement finalisation retries this same finalise POST.
         */
        this.finaliseProfilePictureOperation = function (operationId) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.finaliseProfilePictureOperation(operationId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.mapProfilePictureOperationResult(response)];
                }
            });
        }); };
        if (!client) {
            throw Error('You must provide a pephealth client object.');
        }
    }
    return PEPHealthService;
}());
export default PEPHealthService;
//# sourceMappingURL=service.js.map